import React from "react";
import {
    Box,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    DialogContentText,
    Tab,
} from "@mui/material";
import {
    Close,
} from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { useDispatch, useSelector } from "react-redux";
import {
    StyledDarkRedInformationTypography,
    StyledNestedTabs,
} from "../../../components/commonComponents/StyledComponents/styled";
import PropTypes from "prop-types";
import {
    resetEditSectionDetails,
    resetReportSettings,
} from "../../../api_calls/ReportSettings";
import PerformanceWorkspace from "./ReportSectionTabs/PerformanceWorkspace";
import ImpressionsWorkspace from "./ReportSectionTabs/ImpressionsWorkspace";

// to load tab content
function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const WorkspaceSections = ({ open, size, closeModal }) => {
    const currentStateData = useSelector((state) => state.userSelections);
    const [tabValue, setTabValue] = React.useState(0);
    const showImpressionWarning = typeof currentStateData.workspace_report_sections !== "undefined" && currentStateData.workspace_report_sections !== null && currentStateData.workspace_report_sections.length > 0 ? currentStateData.workspace_report_sections.filter(sec => sec.type === "impression").length === 0 : true;

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    let tabs = [
        {
            label: "Performance Sections",
            // icon: <Visibility />,
            unique_key: "workspace_performance_sections",
            content: <PerformanceWorkspace />,
        },
        {
            label: "Impressions Sections",
            // icon: <Visibility />,
            unique_key: "workspace_impressions_sections",
            content: <ImpressionsWorkspace />,
        },
    ];

    return (
        <>
            <Dialog
                open={open}
                onClose={(e) => {
                    e.preventDefault();
                }}
                fullWidth={true}
                maxWidth={size}
            >
                <DialogTitle>
                    <strong>Workspace Report Sections</strong>
                </DialogTitle>
                <DialogContent>
                    {/* ------ warning text for impressions dashboard -------- */}
                    {
                        showImpressionWarning && (
                            <>
                                <DialogContentText>
                                    <Stack direction={"row"} spacing={3}>
                                        {/* ------ warning text when impressions aren't yet added ------ */}
                                        <Box>
                                            <StyledDarkRedInformationTypography variant="body2">
                                                Warning: This workspace has no Impressions dashboard saved for new reports! Automated publishing of Impressions Reports is disabled.
                                            </StyledDarkRedInformationTypography>
                                        </Box>
                                    </Stack>
                                </DialogContentText>
                                <Box height={30} />
                            </>
                        )
                    }

                    <StyledNestedTabs value={tabValue} onChange={handleChange} aria-label="brand analytics" textColor={"#F04B55"}>
                        {tabs.map((tabDetail) => {
                            return <Tab
                                key={tabDetail.unique_key}
                                aria-label={tabDetail.label}
                                label={tabDetail.label}
                                sx={{ width: "100%", maxWidth: "555px" }}
                                {...a11yProps(0)}
                            />;
                        })}
                    </StyledNestedTabs>

                    {/* ============== tab contents =========== */}
                    {tabs.map((tabDetail, index) => {
                        return (
                            <CustomTabPanel value={tabValue} index={index}>
                                {tabDetail.content}
                            </CustomTabPanel>
                        );
                    })}

                </DialogContent>

                <Box height={20} />
                <DialogActions>
                    <Stack direction={"row"} spacing={2}>
                        <CloseButton
                            onClick={(e) => {
                                e.preventDefault();
                                resetReportSettings();
                                resetEditSectionDetails();
                                closeModal();
                            }}
                            label="Close"
                            icon={<Close />}
                        />
                    </Stack>
                </DialogActions>
            </Dialog >

        </>
    );
};

export default WorkspaceSections;
